import { ApiClientErrorResponse } from '~/ApiClient';

import { ErrorCode } from './Error';
import { mapError } from './mapError';
import { ValidationResult } from './ValidationResult';

export class ErrorResponse extends ApiClientErrorResponse {
	handleCalculationRequiresAtLeastOneReferenceCountryProduct(): boolean {
		return this.handle(ErrorCode.ReferenceCountryProductMissingErrorCode);
	}

	handleCalculationRequiresAtMostOneProductForEachCountry(): boolean {
		return this.handle(ErrorCode.OnlyOneProductPerCountryErrorCode);
	}

	handleProductGroupNotFound(): boolean {
		return this.handle('product-group-not-found');
	}

	handleCalculationRequiresReferenceSettings(): boolean {
		return this.handle(ErrorCode.RequiresReferenceSettingsErrorCode);
	}

	handleCalculationRequiredProductSettingsIsMissing(): boolean {
		return this.handle(ErrorCode.RequiredProductSettingsMissingErrorCode);
	}

	handleProductGroupLocked(): boolean {
		return this.handle('product-group-locked');
	}

	handleCannotChangeSettingsForNonMemberProducts(): boolean {
		return this.handle('czech-max-price-calculation-cannot-change-settings-for-non-member-products');
	}

	handleMissingThreeReferenceCountryProductsErrorCode(): boolean {
		return this.handle(ErrorCode.MissingThreeReferenceCountryProductsErrorCode);
	}

	handleIllegalPriceTypeSelected(): boolean {
		return this.handle(ErrorCode.IllegalPriceTypeSelectedErrorCode);
	}

	toValidationResult(): ValidationResult {
		const errors = this.errors.map(mapError);

		return new ValidationResult(
			errors.find((error) => error.code === ErrorCode.RequiresReferenceSettingsErrorCode) !== undefined,
			errors.filter((error) => error.productId !== null),
			errors.filter((error) => error.duplicateCountries.length > 0)
		);
	}
}
